// components/FeaturedProducts.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import "../styles/FeaturedProducts.css";

const FeaturedProducts = () => {
    const [featured, setFeatured] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFeatured = async () => {
            try {
                // Fetch all products
                const querySnapshot = await getDocs(collection(db, "products"));
                const all = [];
                querySnapshot.forEach((d) => {
                    const data = d.data();
                    all.push({
                        id: d.id,
                        name: data.name || "Unnamed Product",
                        price: data.price || 0,
                        price_cents: data.price ? data.price * 100 : 0,
                        image: data.images?.[0] || data.image || "https://placehold.co/500x700",
                        images: data.images || [],
                        description: data.description || "",
                        soldOut: data.soldOut || false,
                        stock: data.stock || 0,
                        category: data.category || "Uncategorized",
                        variants: data.variants || [],
                        featured: data.featured || false,
                    });
                });

                // Check for admin-curated featured IDs in site_config first
                const configRef = doc(db, "site_config", "home_content");
                const configSnap = await getDoc(configRef);

                let preview = [];

                if (configSnap.exists() && configSnap.data().featuredProductIds?.length > 0) {
                    // Use the admin-selected order
                    const ids = configSnap.data().featuredProductIds;
                    preview = ids
                        .map(id => all.find(p => p.id === id))
                        .filter(Boolean)
                        .slice(0, 3);
                }

                // Fallback: products marked featured in ProductManager, then first 3
                if (preview.length === 0) {
                    const markedFeatured = all.filter(p => p.featured);
                    preview = markedFeatured.length >= 3
                        ? markedFeatured.slice(0, 3)
                        : all.slice(0, 3);
                }

                setFeatured(preview);
            } catch (err) {
                console.error("Error fetching featured products:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchFeatured();
    }, []);

    if (loading) {
        return (
            <section className="featured-section">
                <div className="container text-center py-5">
                    <div className="spinner-border" role="status" style={{ color: "var(--primary-gold, #d4af37)" }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </section>
        );
    }

    if (featured.length === 0) return null;

    return (
        <section className="featured-section">
            <div className="featured-heading">
                <span className="eyebrow">Handpicked for you</span>
                <h2>FEATURED PRODUCTS</h2>
                <div className="featured-divider" />
            </div>

            <div className="featured-grid">
                {featured.map((product) => (
                    <div key={product.id} className="featured-card">
                        <Link
                            to={`/product/${product.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                        >
                            <ProductCard product={product} />
                        </Link>
                    </div>
                ))}
            </div>

            <div className="featured-cta">
                <Link to="/shop">View Full Collection</Link>
            </div>
        </section>
    );
};

export default FeaturedProducts;